// extracted by mini-css-extract-plugin
module.exports = {"productButtonWrapper":"index__productButtonWrapper___2AoLX","productButton":"index__productButton___1QHyX"};